import ZJApp from '../../../../app'

let utils = ZJApp.ZJUtils;
let ZJApi = ZJApp.ZJApis.ZJApi;

const info = {
    service: 'HuaweiOpenApiService',
    controller: 'CameraService'
};

const methods = [
    'GetPreviewStreamInfo',
    'PtzControl',
    'GetPlayBackStreamInfo'
];

const factory = (Fun)=>{
    utils.extend(Fun.prototype, info)
    methods.forEach(path => {
        Fun.prototype[path] = function(data) {
            return this.post(path, data)
        }
    })
};

const HuaweiOpenApi = ZJApi.defineNewApi('HuaweiOpenApi', factory);

export default HuaweiOpenApi;